import { cookie, request } from "../@utils";
import store from "../@store";
const AuthService = {
  login: async ({ loginType, password, username }) => {
    const res = await request.post("auth/login", {
      data: { loginType, password, username },
    });
    cookie.set("authorization", res);
    store.dispatch({ type: "auth/login", payload: res });
    return res;
  },
  logout: () => {
    cookie.remove("authorization");
    localStorage.removeItem('storeCode');
    store.dispatch({ type: "auth/logout" });
    store.dispatch({ type: "store/list" });
  },
  userInfo: async () => {
    const res = await request.get("auth/user-info");
    store.dispatch({ type: "auth/userInfo", payload: res });
    return res;
  },
};
export default AuthService;
